"use client";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import bgNav from "../assets/images/Subtract.png";

import RouletteIcon from "../assets/images/Roulette.svg?react";
import HomeIcon from "../assets/icons/Home.svg?react";
import GiftIcon from "../assets/icons/Gift.svg?react";
import TrophyIcon from "../assets/icons/Trophy.svg?react";
import UserIcon from "../assets/icons/User.svg?react";
import { useBottomNav } from '../context/BottomNavContext';

export default function BottomNav() {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation((prev) => (prev + 1) % 360);
    }, 20);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <nav
        className="fixed bottom-0 left-0 right-0 w-full text-white z-10 h-[100px] max-xs:h-[80px]"
        style={{
          backgroundImage: `url(${bgNav})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover", // Adjust as needed (e.g., cover, auto)
          // height: "100px", // Increase the height here
        }}
      >
        <div className="flex justify-around items-center p-2">
          <Link to="/" className="flex flex-col items-center">
            <HomeIcon className="object-contain max-xs:w-[40px]"  />

            <span className="text-xs max-xs:text-[10px]">Home</span>
          </Link>

          <Link to="/promotions" className="flex flex-col items-center">
            <GiftIcon className="  object-contain  max-xs:w-[53px]" />

            <span className="text-xs max-xs:text-[10px]">Promotion</span>
          </Link>

          <Link to="/play-game" className="flex flex-col items-center -mt-6">
            <div
              className="rounded-full flex items-center justify-center"
              style={{
                transform: `rotate(${rotation}deg)`,
                background: "linear-gradient(180deg, #FFE600 0%, #FC9703 100%)", // Proper string format
              }}
            >
              <RouletteIcon className="object-contain" />
            </div>
            <span className="text-xs max-xs:text-[10px] mt-1">Games</span>
          </Link>

          <Link to="/game-results" className="flex flex-col items-center">
            <TrophyIcon className="  object-contain max-xs:w-[43px]" />

            <span className="text-xs max-xs:text-[10px]">Results</span>
          </Link>

          <Link to="/account" className="flex flex-col items-center">
            <UserIcon className="  object-contain max-xs:w-[43px] " />

            <span className="text-xs max-xs:text-[10px]">Account</span>
          </Link>
        </div>
      </nav>
    </>
  );
}

